var map = {
	"./admin.ts": 81,
	"./attach.ts": 150,
	"./config.ts": 122,
	"./dashboard.ts": 492,
	"./declare.ts": 151,
	"./edu.ts": 54,
	"./edumain.ts": 118,
	"./exam.ts": 38,
	"./form.ts": 181,
	"./license.ts": 171,
	"./log.ts": 211,
	"./login.ts": 96,
	"./phishing.ts": 123,
	"./quiz.ts": 199,
	"./register.ts": 193,
	"./share.ts": 197,
	"./startExam.ts": 109,
	"./tag.ts": 112,
	"./target.ts": 76,
	"./template.ts": 87,
	"./user.ts": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1295;